module.exports = __webpack_public_path__ + "static/media/no-image.a5067985.png";